import $ from "jquery"
import {ReportGroupingLevel} from './constants'

export default function ProfitLossDisplayedDataSelector(){}

ProfitLossDisplayedDataSelector.prototype.init = function(radioGroupSelectorId,
                                                          firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, changeCallback ){
    this.selectorId = $("#" + radioGroupSelectorId);
    this.customerGroupingChexBox =   this.selectorId.find("[value=customerGrouping]" );
    this.customerGroupingChexBox.on("change", changeCallback);
    this.customerProjectGroupingChexBox =   this.selectorId.find("[value=customerProjectGrouping]" );
    this.customerProjectGroupingChexBox.on("change", changeCallback);
    this.customerProjectTaskGroupingChexBox =   this.selectorId.find("[value=customerProjectTaskGrouping]" );
    this.customerProjectTaskGroupingChexBox.on("change", changeCallback);
    this.setValue(firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel);
    return this;
};

ProfitLossDisplayedDataSelector.prototype.setValue =function(firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel){
    if(thirdGroupingLevel == ReportGroupingLevel.NONE){
        if(secondGroupingLevel == ReportGroupingLevel.NONE){
            this.customerGroupingChexBox.prop("checked", true);
            return;
        }
        this.customerProjectGroupingChexBox.prop("checked", true);
        return;
    }
    this.customerProjectTaskGroupingChexBox.prop("checked", true);
};

ProfitLossDisplayedDataSelector.prototype.getValue =function(){
    return{
        firstGroupingLevel: ReportGroupingLevel.CUSTOMER,
        secondGroupingLevel: this.customerGroupingChexBox.is(":checked") ? ReportGroupingLevel.NONE : ReportGroupingLevel.PROJECT,
        thirdGroupingLevel:  this.customerProjectTaskGroupingChexBox.is(":checked") ? ReportGroupingLevel.TASK :  ReportGroupingLevel.NONE
    }
};





// WEBPACK FOOTER //
// ./web/js/reports/ProfitLossDisplayedDataSelector.js